import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BudgetDetailDetailService {

  constructor(private httpClient: HttpClient) { }

  async getCostTypeAll() {
    const result: any = await this.httpClient.get(`plan/api/business/budget/budgetDetail/cost`).toPromise();
    return result.data;
  }

  async getBudgetDetailListByCondition(param: any, pageNum: number, pageSize: number) {
    let url = `plan/api/business/budget/budgetDetails?pageNum=${pageNum}&pageSize=${pageSize}`;
    if (!this.isEmpty(param.bdName)) {
      url = url + `&bdName=${param.bdName}`;
    }
    if (!this.isEmpty(param.costTypeId)) {
      url = url + `&costTypeId=${param.costTypeId}`;
    }
    const result: any = await this.httpClient.get(url).toPromise();
    return result.data;
  }

  async getBudgetDetail(pbid: string) {
    const url = `plan/api/business/budget/budgetDetail/${pbid}`;
    const result: any = await this.httpClient.get(url).toPromise();
    return result.data;
  }

  // 这里不知道如何用httpclient请求，暂时用axios
  async batchDelete(bdids: any) {
    const ls: string[] = Array.from(bdids);
    const result: any = await this.httpClient.delete(`plan/api/business/budget/budgetDetails/`, { params: { bdids: ls } }).toPromise();
    return result.data;
  }

  async updateBudgetDetail(budgetDetail: any) {
    const result: any = await this.httpClient.put(`plan/api/business/budget/budgetDetail/`, budgetDetail).toPromise();
    return result;
  }

  async addBudgetDetail(budgetDetail: any) {
    const result: any = await this.httpClient.post(`plan/api/business/budget/budgetDetail/`, budgetDetail).toPromise();
    return result.data;
  }

  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
